var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"opt-img",staticStyle:{"width":"100%","height":"100%"},attrs:{"src":("" + (require('@assets/images/dywfl/xmjs.jpg'))),"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }